<script setup lang="ts">
/**
 * Сборка релиза из карточки задачи: та же форма, что на экране раздела, но в
 * модалке — в карточке для колонки справа места нет.
 *
 * Список репозиториев подсказывает сервис: он смотрит, до каких проектов
 * задачи эпика дошли через merge request'ы.
 */
import { AppButton, AppModal } from '@vinprop/design-system'
import { onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'

import { listReleaseServices } from '../api'
import ReleaseForm from './ReleaseForm.vue'

const props = defineProps<{ issueId: string; issueKey: string; epicId?: string }>()

const emit = defineEmits<{ done: []; failed: [error: unknown]; close: [] }>()

const { t } = useI18n()

const services = ref<string[]>([])
const form = ref<InstanceType<typeof ReleaseForm> | null>(null)

const load = async () => {
  if (!props.epicId) return

  try {
    services.value = await listReleaseServices(props.epicId)
  } catch (failure) {
    emit('failed', failure)
  }
}

onMounted(load)
</script>

<template>
  <AppModal
    model-value
    :title="t('devops.release.title')"
    size="small"
    @update:model-value="emit('close')"
  >
    <ReleaseForm
      ref="form"
      :services="services"
      :issue-id="issueId"
      :issue-key="issueKey"
      @done="emit('done')"
      @failed="emit('failed', $event)"
    >
      <!-- Кнопки модалки живут в её футере: пустой слот убирает вторую пару -->
      <template #actions><span /></template>
    </ReleaseForm>

    <template #footer>
      <AppButton variant="secondary" @click="emit('close')">
        {{ t('common.actions.cancel') }}
      </AppButton>
      <AppButton :loading="form?.busy" :disabled="!form?.canSubmit" @click="form?.submit()">
        {{ t('devops.release.create') }}
      </AppButton>
    </template>
  </AppModal>
</template>
